// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1eE8R","featured":"Card_featured__At4Wi"};